import React, { useEffect } from "react";
import { toast } from "react-toastify";
import MyEditor from "../Common/MyEditor";
import { Col, Row, Button, Modal, Label, Input, ModalHeader, ModalBody, ListGroup, ListGroupItem } from "@/Components/Common/Tailwind";

import { useNavigate } from "react-router-dom";
import { SITE_ID } from "../../assets/meta/meta";
import { getAccessToken } from "../../api/auth";
import { DragDropContext, Draggable, Droppable, type DragStart, type DropResult } from "@hello-pangea/dnd";
import heic2any from "heic2any";
import {
  updateSiteSlogan,
  updateSiteFooter,
  updateSiteLocation,
  updateSnsLink,
  deleteSnsLink,
  createSnsLink
} from "../../api/services/site.service";
import {
  getCarouselById,
  updateCarouselImage,
  deleteCarouselImage,
  uploadCarouselImage,
  updateCarouselOrder,
  addCarousel,
  deleteCarousel
} from "../../api/services/carousel.service";
import { updateContentImage, updateContentDescription, updateContentInfo } from "../../api/services/content.service";
import { API } from "../../api";
import Select, { type MultiValue } from "react-select";
import { useUserStore } from "../../store/store";

interface SloganModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  origin: string;
  navigate: (path: number | string) => void;
  site: number;
  slogan?: boolean;
  setSlogan?: (slogan: boolean) => void;
}

const SloganModal = (props: SloganModalProps) => {
  const [content, setContent] = React.useState(props.origin);
  const [textcontent, setTextContent] = React.useState(props.origin);

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const togSlogan = () => {
    if (props.setSlogan && props.slogan !== undefined) {
      props.setSlogan(!props.slogan);
    }
  };

  const updateSlogan = async () => {
    try {
      let value = textcontent;
      if (!value) value = "";
      await updateSiteSlogan(String(props.site), value);
      props.navigate(0);
    } catch (error) {
      toast.error("Update slogan fail");
      console.error(error);
    }
  };


  useEffect(() => {
    setContent(props.origin);
  }, [props.origin]);

  return (
    <Modal isOpen={props.visible} toggle={togModal} centered>
      <div className="my-3 mx-3">
        <Label htmlFor="basiInput" className="form-label fs-15">
          슬로건 수정
        </Label>
        <MyEditor
          value={content}
          onChange={setContent}
          noImage={true}
          onTextChange={(textvalue) => {
            setTextContent(textvalue);
          }}
        />
        {/* <Input type="text" className="form-control" id="basiInput" value={props.sloganText} onChange={(e)=>InputEditText(e)}/> */}
        {/* <div className="form-check form-switch form-switch-md my-2" dir="ltr">
                    <Input type="checkbox" className="form-check-input" id="sloganSwitchbox"
                        onChange={togSlogan} checked={props.slogan?true:false}
                    />
                    <Label for="sloganSwitchbox">슬로건 표시 여부</Label>
                </div> */}
        <div>내용을 빈칸으로 비우면 슬로건 컨텐츠 영역이 숨겨집니다.</div>
        <div className="flex justify-content-end my-3">
          <Button
            variant="secondary"
            className="ms-2 float-right"
            onClick={() => {
              updateSlogan();
              props.setVisible(!props.visible);
            }}
          // disabled={!props.sloganText}
          >
            적용
          </Button>
          <Button
            variant="secondary"
            className="ms-2 float-right"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
        </div>
      </div>
    </Modal>
  );
};

interface DeleteCarouselModalProps {
  type: number;
  carouselId?: number;
  snsLinkId?: number;
  deleteModal: boolean;
  setDeleteModal: (visible: boolean) => void;
  navigate: (path: number | string) => void;
}

const DeleteCarouselModal = (props: DeleteCarouselModalProps) => {
  const TYPE_MAP: { [key: number]: { url: string; comment: string } } = {
    0: {
      url: `/sites/carousels/${props.carouselId}/`,
      comment: "베너 그룹을",
    },
    1: {
      url: `/sites/link/${props.snsLinkId}/`,
      comment: "SNS 링크를",
    },
  };

  const togDeleteModal = () => {
    props.setDeleteModal(!props.deleteModal);
  };

  const deleteData = async () => {
    try {
      if (props.type === 0 && props.carouselId) {
        await deleteCarousel(String(props.carouselId));
      } else if (props.type === 1 && props.snsLinkId) {
        await deleteSnsLink(String(props.snsLinkId));
      }
      props.navigate(0);
    } catch (error) {
      toast.error("Delete fail");
      console.error(error);
    }
  };

  return (
    <Modal
      id="topmodal"
      isOpen={props.deleteModal}
      toggle={() => {
        togDeleteModal();
      }}
    >
      <ModalHeader
        className="modal-title"
        id="myModalLabel"
        toggle={() => {
          togDeleteModal();
        }}
      >
        삭제하기
      </ModalHeader>
      <ModalBody className="text-center p-5">
        <div style={{ width: "120px", height: "120px" }}></div>
        <div className="mt-4">
          <h5 className="mb-3">{`해당 ${TYPE_MAP[props.type].comment} 삭제하시겠습니까?`}</h5>
          <div className="flex flex-row items-center gap-2 justify-center">
            <Button
              type="button"
              variant="outline"
              className="bg-gradient-light fw-medium"
              onClick={() => {
                togDeleteModal();
              }}
            >
              <i className="ri-close-line me-1 align-middle"></i>닫기
            </Button>
            <Button
              type="button"
              variant="danger"
              onClick={() => {
                deleteData();
                props.setDeleteModal(false);
              }}
            >
              삭제하기
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

interface CarouselItemProps {
  item: any;
  index: number;
  updateCarousel: (data: any) => Promise<any>;
  handleDelete: (id: any) => void;
  urlCollection: any[];
}

const CarouselItem = ({
  item, index, updateCarousel, handleDelete,
  urlCollection,
}: CarouselItemProps) => {
  const [itemUrl, setItemUrl] = React.useState(item.link_url);
  useEffect(() => {
    setItemUrl(item.link_url);
  }, [item.link_url]);
  return (
    <Draggable draggableId={`${item.key}`} key={item.key} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            userSelect: "none",
            padding: 16,
            // margin: "0 0 8px 0",
            marginRight: "4px",
            marginBottom: "2px",
            minHeight: "40px",
            backgroundColor: "#f0f0f0",
            color: "black",
            borderWidth: 0,
            borderRadius: 4,
            // display: "inline-block",
            position: "relative",
            ...provided.draggableProps.style,
            display: "flex",
            gap: "10px",
          }}
        >
          <Button
            size="sm"
            variant="danger"
            style={{ position: "absolute", left: 10, bottom: 10 }}
            onClick={() => {
              handleDelete?.(item.key);
            }}
          >
            <i className="ri-delete-bin-5-line"></i>
          </Button>

          <div className="flex-shrink-0">
            <img src={item.src} alt={"img"} style={{ width: "80px", height: "80px", objectFit: "contain" }} data-position={index} />
          </div>
          <div className="flex-grow-1">
            <div className="flex flex-row items-center gap-2 mt-2">
              <select className="form-select" aria-label="Default select example" name="url" onChange={(e) => setItemUrl(e.target.value)}>
                <option value="">직접입력</option>
                {urlCollection?.map((_item, idx) => {
                  return (
                    <option key={idx} value={_item.url}>
                      {_item.type === "package" && "[예약]"} {_item.type === "ticket" && "[티켓]"}  {_item.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="flex flex-row items-center gap-2 mt-2">
              <div className="flex-grow-1">
                <Input
                  type="text"
                  className="form-control"
                  id={`url-${item.key}`}
                  value={itemUrl}
                  placeholder="URL 입력"
                  onChange={(e) => {
                    const newUrl = e.target.value;
                    setItemUrl(newUrl);
                  }}
                />
              </div>
              <div className="flex-shrink-0">
                <Button
                  style={{}}
                  onClick={() => {
                    if (itemUrl) {
                      updateCarousel?.({ key: item.key, url: itemUrl })?.then(() => {
                        toast.success("수정되었습니다.");
                      }).catch((error) => {
                        toast.error("수정 실패");
                      });
                    }
                  }}
                >
                  수정
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
}

interface CarouselModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  navigate: (path: number | string) => void;
  carouselId: number;
  modalNumber: number;
  carouselData?: any[];
}

const CarouselModal = (props: CarouselModalProps) => {
  const carouselInputRef = React.useRef<HTMLInputElement>(null);
  const [carousel, setCarousel] = React.useState<string[]>([]);

  const [existingCarousel, setExistingCarousel] = React.useState<any[]>([]);

  const [deleteModal, setDeleteModal] = React.useState(false);
  const [nowCarouselList, setNowCarouselList] = React.useState<any[]>([]);

  const [urlCollection, setUrlCollection] = React.useState<any[]>([]);

  useEffect(() => {
    // fetch package and ticket data
    const fetchUrlCollection = async () => {
      const collections: any[] = []
      try {
        const packageresponse = await API.get("/package/items/");
        const data = packageresponse.data;
        data.forEach((item: any) => {
          collections.push({
            id: item.id,
            name: item['상품명'],
            type: 'package',
            url: '/package/' + item.id,
          });
        });

        const ticketresponse = await API.get("/ticket/products/");
        const ticketdata = ticketresponse.data;
        ticketdata.forEach((item: any) => {
          collections.push({
            id: item.id,
            name: item.name,
            type: 'ticket',
            url: '/ticket/' + item.id,
          });
        });
        setUrlCollection(collections);
      } catch (error) {
        console.error("Error fetching package and ticket data:", error);
      }
    };
    fetchUrlCollection();
  }, []);

  useEffect(() => {
    if (props.carouselData) {
      // console.log("props.carouselData", props.carouselData);
      setNowCarouselList(props.carouselData);
    }
  }, [props.carouselData]);

  const togModal = () => {
    setCarousel([]);
    props.setVisible(!props.visible);
  };

  const handleUpdateCarouselOrder = () => {
    const modifiedData = nowCarouselList.map((item, index) => {
      const { id, images, ...rest } = item;
      return {
        id: item.id,
        display_level: index, // 수정하려는 속성을 인덱스 값으로 변경
      };
    });

    let _carouselList = {
      carousels: modifiedData,
    };
    updateCarouselOrder(_carouselList).then((response) => {
      const responseData = response.data;
      props.navigate(0);
    })
      .catch((error) => {
        toast.error("Update carousel fail");
        console.error(error);
      });
  };

  const handleImageFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    console.log("files", files);
    if (!files || files.length === 0) {
      return;
    }
    const imgFiles: string[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // let reader = new FileReader();

      if (file.type === "image/heic" || file.type === "image/heif") {
        const convertedImageBlob = (await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.5,
        })) as Blob;

        const reader = new FileReader();
        reader.readAsDataURL(convertedImageBlob);
        reader.onloadend = () => {
          const base64data = reader.result;
          if (typeof base64data === "string") {
            imgFiles.push(base64data);
          }
          if (imgFiles.length === files.length) {
            setCarousel([...imgFiles]);
            console.log("filesurl", [...imgFiles]);
          }
        };
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          const base64data = reader.result;
          if (typeof base64data === "string") {
            imgFiles.push(base64data);
          }
          if (imgFiles.length === files.length) {
            setCarousel([...imgFiles]);
            console.log("filesurl", [...imgFiles]);
          }
        };
      }

      // reader.onload = () => {
      //   imgFiles[i] = reader.result;
      //   setCarousel([...imgFiles]);
      //   console.log("filesurl", [...imgFiles]);
      // };

      // reader.readAsDataURL(file);
    }
  };

  const handleImageUploadFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    console.log("files", files);
    if (!files || files.length === 0) {
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      let convertFile: File | undefined;
      // let reader = new FileReader();

      if (file.type === "image/heic" || file.type === "image/heif") {
        const convertedBlob = (await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.5,
        })) as Blob;

        convertFile = new File([convertedBlob], `${file.name}.jpeg`, {
          type: convertedBlob.type,
        });
      }

      const formData = new FormData();

      formData.append("img", file.type === "image/heic" || file.type === "image/heif" ? convertFile ?? file : file);
      formData.append("display_level", "0");
      // formData.append("url", "string");
      // formData.append("title", "string");
      // formData.append("description", "string");
      formData.append("carousel", String(props.carouselId));

      handleUpload(formData);
    }
  };

  const handleUpload = async (formData: FormData) => {
    try {
      await uploadCarouselImage(formData);
      fetchCarousel();
    } catch (error) {
      toast.error("Update carousel fail");
      console.error(error);
    }
  };

  const handleDelete = async (id: string | number) => {
    try {
      await deleteCarouselImage(String(id));
      fetchCarousel();
    } catch (error) {
      toast.error("delete carousel fail");
      console.error(error);
    }
  };

  const handleUpdateImgOrder = () => {
    const modifiedData = existingCarousel.map((item, index) => {
      const { display_level, ...rest } = item;
      return {
        ...rest,
        display_level: index,
      };
    });
    console.log("handleUpdateImgOrder", modifiedData);
    const promises: Array<Promise<void>> = [];

    modifiedData.forEach((item) => {
      promises.push(updateCarousel(item));
    });
    Promise.all(promises)
      .then((data) => {
        console.log("handle upload carousel", data);
        props.navigate(0);
      })
      .catch((e) => console.log("Error...", e));
  };

  const fetchCarousel = async () => {
    try {
      const response = await getCarouselById(String(props.carouselId));
      setExistingCarousel(response.data.images);
    } catch (error) {
      console.error(error);
    }
  };

  const updateCarousel = async (data: { key: string | number; display_level: number; url?: string }) => {
    try {
      await updateCarouselImage(String(data.key), data.display_level, String(props.carouselId), data.url ?? "");
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddCarousel = async () => {
    try {
      await addCarousel(carousel);
      fetchCarousel();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!props.carouselId || props.carouselId === -1) {
      return;
    }
    fetchCarousel();
  }, [props.carouselId]);

  const handleOnDragStart = (_start: DragStart) => {
    console.log("Drag started");
  };

  const handleOnDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const newCardGroups = [...carousel];

    const source = result.source;
    const destination = result.destination;

    const [removed] = newCardGroups.splice(source.index, 1);
    newCardGroups.splice(destination.index, 0, removed);

    setCarousel(newCardGroups);
  };

  const handleOnUpdateDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const newCardGroups = [...existingCarousel];

    const source = result.source;
    const destination = result.destination;

    const [removed] = newCardGroups.splice(source.index, 1);
    newCardGroups.splice(destination.index, 0, removed);

    setExistingCarousel(newCardGroups);
  };

  const handleOnCarouselOrderDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const newCardGroups = [...nowCarouselList];

    const source = result.source;
    const destination = result.destination;

    const [removed] = newCardGroups.splice(source.index, 1);
    newCardGroups.splice(destination.index, 0, removed);

    setNowCarouselList(newCardGroups);
  };

  return (
    <React.Fragment>
      <Modal isOpen={props.visible} toggle={togModal} centered>
        {props.modalNumber === -1 ? (
          <Row className="items-center g-3 mx-2 my-3">
            <Col>
              <div>
                <Label htmlFor="formFile" className="form-label">
                  이미지 추가하기
                </Label>
                <p className="text-muted">이미지 여러 장 선택 가능</p>
                <Input id="formFile" className="form-control" type="file" accept="image/*,.heic,.heif" innerRef={carouselInputRef} onChange={(e) => handleImageFiles(e)} multiple />
                <p className="mt-2">
                  드래그로 순서를 변경할 수 있습니다.
                  <br />
                  *최대 업로드 가능: 100mb / *가능한 확장자: png,jpg,jpeg,heic
                </p>
              </div>
            </Col>

            <DragDropContext onDragEnd={handleOnDragEnd} onDragStart={handleOnDragStart}>
              <div>
                <Droppable droppableId="droppable" direction="horizontal">
                  {(provided) => (
                    <div className="card-list" ref={provided.innerRef} {...provided.droppableProps} style={{ display: "flex", padding: "grid", overflow: "auto" }}>
                      {carousel && carousel.length
                        ? carousel.map((url, index) => {
                          return (
                            <Draggable draggableId={`draggable_${index}`} key={index} index={index}>
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{
                                    userSelect: "none",
                                    padding: 16,
                                    margin: "0 0 8px 0",
                                    minHeight: "40px",
                                    backgroundColor: "#f0f0f0",
                                    color: "black",
                                    borderWidth: 0,
                                    borderRadius: 4,
                                    display: "inline-block",
                                    position: "relative",
                                    ...provided.draggableProps.style,
                                  }}
                                >
                                  <Button
                                    style={{ position: "absolute", right: 0 }}
                                    onClick={() => {
                                      setCarousel(carousel.filter((_, i) => i !== index));
                                    }}
                                  >
                                    삭제
                                  </Button>
                                  <img src={url} alt={"img"} style={{ width: "80px", height: "80px", objectFit: "contain" }} data-position={index} />
                                </div>
                              )}
                            </Draggable>
                          );
                        })
                        : null}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </DragDropContext>

            <div className="flex justify-content-end mb-3">
              {props.modalNumber < 0 ? (
                <Button
                  variant="secondary"
                  className="ms-2"
                  onClick={() => {
                    handleAddCarousel();
                    props.setVisible(!props.visible);
                  }}
                  disabled={!carousel.length}
                >
                  추가하기
                </Button>
              ) : null}
              <Button
                variant="secondary"
                className="ms-2"
                onClick={() => {
                  props.setVisible(!props.visible);
                  setCarousel([]);
                }}
              >
                닫기
              </Button>
            </div>
          </Row>
        ) : props.modalNumber >= 0 ? (
          <Row className="items-center g-3 mx-2 my-3">
            <Col>
              <div>
                <Label htmlFor="formFile" className="form-label">
                  {`${props.modalNumber + 1}번 홈 이미지 수정`}
                </Label>
                <p className="text-muted">이미지 여러 장 선택 가능</p>
                <Input id="formFile" className="form-control" type="file" accept="image/*,.heic,.heif" innerRef={carouselInputRef} onChange={(e) => handleImageUploadFiles(e)} multiple />
                <p className="mt-2">
                  드래그로 순서를 변경할 수 있습니다.
                  <br />
                  *최대 업로드 가능: 100mb / *가능한 확장자: png,jpg,jpeg,heic
                </p>

                <DragDropContext onDragEnd={handleOnUpdateDragEnd} onDragStart={handleOnDragStart}>
                  <div>
                    <Droppable droppableId="droppable2" direction="vertical">
                      {(provided) => (
                        <div className="card-list" ref={provided.innerRef} {...provided.droppableProps} style={{ display: "flex", padding: "grid", overflowX: "hidden", overflowY: "scroll" }}>
                          {existingCarousel && existingCarousel.length > 0
                            ? existingCarousel.map((img, index) => {
                              return (
                                <CarouselItem
                                  key={index}
                                  item={img}
                                  index={index}
                                  updateCarousel={(data) => {
                                    return updateCarousel(data)
                                      .then(() => {
                                        toast.success("수정되었습니다.");
                                      })
                                      .catch((error) => {
                                        toast.error("수정 실패");
                                      });
                                  }}
                                  handleDelete={handleDelete}
                                  urlCollection={urlCollection}
                                />
                              );
                            })
                            : null}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </div>
                </DragDropContext>
              </div>
            </Col>

            <div className="flex justify-content-end mb-3">
              <React.Fragment>
                <Button
                  variant="ghost"
                  className="ms-2 btn-soft-danger"
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                >
                  삭제하기
                </Button>
                <Button
                  variant="secondary"
                  className="ms-2"
                  onClick={() => {
                    handleUpdateImgOrder();
                    props.setVisible(!props.visible);
                  }}
                  disabled={existingCarousel.length === 0}
                >
                  적용
                </Button>
              </React.Fragment>

              <Button
                variant="secondary"
                className="ms-2"
                onClick={() => {
                  props.setVisible(!props.visible);
                  setCarousel([]);
                  props.navigate(0);
                }}
              >
                닫기
              </Button>
            </div>
          </Row>
        ) : (
          <Row className="items-center g-3 mx-2 my-3">
            <Col>
              <div>
                <Label htmlFor="formFile" className="form-label">
                  베너 그룹 순서 변경
                </Label>
                <p>드래그로 순서를 변경할 수 있습니다.</p>

                <DragDropContext onDragEnd={handleOnCarouselOrderDragEnd} onDragStart={handleOnDragStart}>
                  <div>
                    <Droppable droppableId="droppable3">
                      {(provided) => (
                        <div className="card-list" ref={provided.innerRef} {...provided.droppableProps}>
                          {nowCarouselList && nowCarouselList.length > 0
                            ? nowCarouselList.map((item, index) => {
                              return (
                                <Draggable draggableId={`draggable3_${index}`} key={index} index={index}>
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={{
                                        userSelect: "none",
                                        padding: 16,
                                        margin: "0 0 8px 0",
                                        minHeight: "40px",
                                        backgroundColor: "#f0f0f0",
                                        color: "black",
                                        borderWidth: 0,
                                        borderRadius: 4,

                                        ...provided.draggableProps.style,
                                      }}
                                    >
                                      {item.id}번 베너 그룹(현재 {index + 1}번째)
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })
                            : null}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </div>
                </DragDropContext>
              </div>
            </Col>

            <div className="flex justify-content-end mb-3">
              <Button
                variant="secondary"
                className="ms-2"
                onClick={() => {
                  handleUpdateCarouselOrder();
                  props.setVisible(!props.visible);
                }}
                disabled={!nowCarouselList.length}
              >
                적용
              </Button>
              <Button
                variant="secondary"
                className="ms-2"
                onClick={() => {
                  props.setVisible(!props.visible);
                  setCarousel([]);
                }}
              >
                닫기
              </Button>
            </div>
          </Row>
        )}
      </Modal>

      {/* Delete Modal */}
      <DeleteCarouselModal type={0} carouselId={props.carouselId} deleteModal={deleteModal} setDeleteModal={setDeleteModal} navigate={props.navigate} />
    </React.Fragment>
  );
};

// 기존의 데이터가 모달의 에디터에 안 들어감 => 아직 해결 안 됨.(2022-11-05)
interface FooterModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  origin: string;
  navigate: (path: number | string) => void;
  site: number;
}

const FooterModal = (props: FooterModalProps) => {
  const [content, setContent] = React.useState(props.origin);

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const updateFooter = async () => {
    try {
      await updateSiteFooter(String(props.site), content);
      props.navigate(0);
    } catch (error) {
      toast.error("Update footer fail");
      console.error(error);
    }
  };

  useEffect(() => {
    setContent(props.origin);
  }, [props.origin]);

  return (
    <Modal isOpen={props.visible} toggle={togModal} centered>
      <div className="mx-3 my-3">
        <h3>상세정보 수정</h3>
        <MyEditor value={content} onChange={setContent} noImage={true} />
        <div className="flex justify-content-end my-3">
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              updateFooter();
              props.setVisible(!props.visible);
            }}
            disabled={!content}
          >
            적용
          </Button>
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
        </div>
      </div>
    </Modal>
  );
};

interface FooterSnsEditModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  snsList: any[];
  navigate: (path: number | string) => void;
}

const FooterSnsEditModal = (props: FooterSnsEditModalProps) => {
  const [deleteTarget, setDeleteTarget] = React.useState(-1);
  const [deleteModal, setDeleteModal] = React.useState(false);

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const updateSnsLinkHandler = async (id: number) => {
    try {
      const url = (document.getElementById(`link-${id}`) as HTMLInputElement).value;
      await updateSnsLink(String(id), url);
      props.navigate(0);
    } catch (error) {
      toast.error("Update SNS Link fail");
      console.error(error);
    }
  };

  return (
    <React.Fragment>
      <Modal isOpen={props.visible} toggle={togModal} centered>
        <Row className="items-center g-3 mx-2 my-3">
          <Col lg={12}>
            <Label htmlFor="none" className="form-label">
              SNS 수정
            </Label>
            {props.snsList.length !== 0 ? (
              <ListGroup>
                {props.snsList.map((item, idx) => {
                  return (
                    <ListGroupItem key={idx} tag="label">
                      {/* <Input className="form-check-input me-1" type="checkbox" value={item.id} /> */}
                      <i className={`ri-${item.sns}-fill align-middle lh-1 me-2`}></i>
                      {`${item.sns} - 주소: ${item.url}`}
                      <Row className="mt-4">
                        <Col lg={7} xs={6}>
                          <Input type="text" className="form-control" id={`link-${item.id}`} placeholder="수정할 주소를 입력해주세요" />
                        </Col>
                        <Col lg={5} xs={6}>
                          <Button
                            variant="secondary"
                            className="ms-2"
                            onClick={() => {
                              updateSnsLinkHandler(item.id);
                            }}
                          >
                            수정
                          </Button>
                          <Button
                            variant="ghost"
                className="ms-2 btn-soft-danger"
                            onClick={() => {
                              setDeleteTarget(item.id);
                              setDeleteModal(true);
                            }}
                          >
                            삭제
                          </Button>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  );
                })}
              </ListGroup>
            ) : null}
          </Col>
          <div className="flex justify-content-end mb-3">
            <Button
              variant="secondary"
              className="ms-2"
              onClick={() => {
                props.setVisible(!props.visible);
              }}
            >
              닫기
            </Button>
          </div>
        </Row>
      </Modal>

      {/* Delete Modal */}
      <DeleteCarouselModal type={1} snsLinkId={deleteTarget} deleteModal={deleteModal} setDeleteModal={setDeleteModal} navigate={props.navigate} />
    </React.Fragment>
  );
};

interface FooterSnsAddModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  navigate: (path: number | string) => void;
}

const FooterSnsAddModal = (props: FooterSnsAddModalProps) => {
  const [selectSnsOption, setSelectSnsOption] = React.useState("");
  const [link, setLink] = React.useState("");

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const addSns = async () => {
    try {
      await createSnsLink("0", selectSnsOption, link);
      props.navigate(0);
    } catch (error) {
      toast.error("Create SNS link fail");
      console.error(error);
    }
  };

  return (
    <Modal isOpen={props.visible} toggle={togModal} centered>
      <Row className="items-center g-3 mx-2 my-3">
        <Col lg={12}>
          <Label className="form-label fs-15">SNS 링크 추가</Label>
          <select className="form-select mb-3" aria-label="Default select example" name="sns" onChange={(e) => setSelectSnsOption(e.target.value)}>
            <option value="">옵션을 선택해 주세요</option>
            <option value="facebook">facebook</option>
            <option value="instagram">instagram</option>
          </select>

          <div>
            <Label htmlFor="basicInput" className="form-label">
              SNS 계정 주소를 입력해주세요
            </Label>
            <Input disabled={!selectSnsOption} type="text" className="form-control" id="basicInput" onChange={(e) => setLink(e.target.value)} />
          </div>
        </Col>
        <div className="flex justify-content-end mb-3">
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              addSns();
              props.setVisible(!props.visible);
            }}
            disabled={!(link && selectSnsOption)}
          >
            적용
          </Button>
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
        </div>
      </Row>
    </Modal>
  );
};

/* 로그인 타이틀 이미지 모달 */
interface LoginTitleImgModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const LoginTitleImgModal = (props: LoginTitleImgModalProps) => {
  const [image, setImage] = React.useState([]);
  const imageInputRef = React.useRef(null);

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  return (
    <Modal isOpen={props.visible} toggle={togModal} centered>
      <Row className="items-center g-3 mx-2 my-3">
        <Col>
          <div>
            <Label htmlFor="formFile" className="form-label">
              로그인 타이틀 이미지 수정
            </Label>
            <Input className="form-control" id="formFile" accept="image/jpg, image/jpeg, image/png" type="file" innerRef={imageInputRef} />
          </div>
        </Col>
        <div className="flex justify-content-end mb-3">
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            적용
          </Button>
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
        </div>
      </Row>
    </Modal>
  );
};

/* kakaomap 페이지 모달 */
interface KakaoMapModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  navigate: (path: number | string) => void;
  isNotice?: boolean;
  setAddress?: (address: string) => void;
}

type DaumPostcodeData = {
  userSelectedType: string;
  roadAddress: string;
  jibunAddress: string;
  bname: string;
  buildingName: string;
  apartment: string;
  zonecode: string;
  address: string;
};

const KakaoMapModal = (props: KakaoMapModalProps) => {
  const { daum } = window as any;

  const [address, setAddress] = React.useState("");
  const [detailAddress, setDetailAddress] = React.useState("");

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const updateCoordinate = async () => {
    try {
      const addressResult = address + " " + detailAddress;
      await updateSiteLocation(String(SITE_ID), addressResult);
      props.navigate(0);
    } catch (error) {
      toast.error("Update map fail");
      console.error(error);
    }
  };

  const addressSearch = () => {
    new daum.Postcode({
      oncomplete: function (data: DaumPostcodeData) {
        // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

        const extraAddressElement = document.getElementById("extraAddress") as HTMLInputElement | null;
        const postcodeElement = document.getElementById("postcode") as HTMLInputElement | null;
        const addressElement = document.getElementById("address") as HTMLInputElement | null;
        const detailAddressElement = document.getElementById("detailAddress") as HTMLInputElement | null;

        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
        let addr = ""; // 주소 변수
        let extraAddr = ""; // 참고항목 변수

        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === "R") {
          // 사용자가 도로명 주소를 선택했을 경우
          addr = data.roadAddress;
        } else {
          // 사용자가 지번 주소를 선택했을 경우(J)
          addr = data.jibunAddress;
        }

        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
        if (data.userSelectedType === "R") {
          // 법정동명이 있을 경우 추가한다. (법정리는 제외)
          // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
          if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
            extraAddr += data.bname;
          }
          // 건물명이 있고, 공동주택일 경우 추가한다.
          if (data.buildingName !== "" && data.apartment === "Y") {
            extraAddr += extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
          }
          // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
          if (extraAddr !== "") {
            extraAddr = " (" + extraAddr + ")";
          }
          // 조합된 참고항목을 해당 필드에 넣는다.
          if (extraAddressElement) {
            extraAddressElement.value = extraAddr;
          }
        } else if (extraAddressElement) {
          extraAddressElement.value = "";
        }

        // 우편번호와 주소 정보를 해당 필드에 넣는다.
        if (postcodeElement) {
          postcodeElement.value = data.zonecode;
        }
        if (addressElement) {
          addressElement.value = addr;
        }
        // 커서를 상세주소 필드로 이동한다.
        detailAddressElement?.focus();
        setAddress(data.address);
      },
    }).open();
  };

  return (
    <Modal isOpen={props.visible} toggle={togModal} centered>
      <Row className="items-center g-3 mx-2 my-3">
        <Col>
          <div className="flex mb-3 justify-between">
            <input disabled type="text" className="form-control w-50" id="postcode" placeholder="우편번호"></input>
            <Button type="button" onClick={() => addressSearch()}>
              우편번호 찾기
            </Button>
          </div>
          <input type="text" className="form-control mb-3" onChange={(e) => setAddress(e.target.value)} id="address" placeholder="주소" disabled></input>
          <input type="text" className="form-control mb-3" id="detailAddress" onChange={(e) => setDetailAddress(e.target.value)} placeholder="상세주소"></input>
          <input disabled type="text" className="form-control w-25" id="extraAddress" placeholder="참고항목"></input>
        </Col>

        <div className="flex justify-content-end mb-3">
          {props.isNotice ? (
            <Button
              variant="secondary"
              className="ms-2"
              onClick={() => {
                props.setAddress?.(address + detailAddress);
                props.setVisible(!props.visible);
              }}
            >
              입력
            </Button>
          ) : (
            <Button
              variant="secondary"
              className="ms-2"
              onClick={() => {
                updateCoordinate();
                props.setVisible(!props.visible);
              }}
            >
              적용
            </Button>
          )}

          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
        </div>
      </Row>
    </Modal>
  );
};

/* detail 페이지 모달*/
interface DetailImgModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  navigate: (path: number | string) => void;
  type: string;
  itemId: number;
}

const DetailImgModal = (props: DetailImgModalProps) => {
  const navigate = useNavigate();
  const imageInputRef = React.useRef<HTMLInputElement | null>(null);

  const [image, setImage] = React.useState<string[]>([]);

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const handleImageFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    if (!files || files.length === 0) {
      return;
    }
    const imgFiles: string[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // let reader = new FileReader();
      if (file.type === "image/heic" || file.type === "image/heif") {
        const convertedImageBlob = (await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.5,
        })) as Blob;

        const reader = new FileReader();
        reader.readAsDataURL(convertedImageBlob);
        reader.onloadend = () => {
          const base64data = reader.result;
          if (typeof base64data === "string") {
            imgFiles.push(base64data);
          }
          if (imgFiles.length === files.length) {
            setImage([...imgFiles]);
          }
        };
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          const base64data = reader.result;
          if (typeof base64data === "string") {
            imgFiles.push(base64data);
          }
          if (imgFiles.length === files.length) {
            setImage([...imgFiles]);
          }
        };
      }

      // reader.onload = () => {
      //   imgFiles[i] = reader.result;
      //   setImage([...imgFiles]);
      // };

      // reader.readAsDataURL(file);
    }
  };

  const updateImage = async () => {
    try {
      await updateContentImage(props.type, String(props.itemId), image);
      props.navigate(0);
    } catch (error) {
      toast.error("Update image fail");
      console.error(error);
    }
  };

  return (
    <Modal isOpen={props.visible} toggle={togModal} centered>
      <Row className="items-center g-3 mx-2 my-3">
        <Col>
          <div>
            <Label htmlFor="formFile" className="form-label">
              상세이미지 수정
            </Label>
            <Input className="form-control" id="formFile" accept="image/*,.heic,.heif" type="file" innerRef={imageInputRef} onChange={(e) => handleImageFiles(e)} multiple />
          </div>
        </Col>
        <div className="flex justify-content-end mb-3">
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              updateImage();
              props.setVisible(!props.visible);
            }}
          >
            적용
          </Button>
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
        </div>
      </Row>
    </Modal>
  );
};

interface DetailInfoModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  navigate: (path: number | string) => void;
  type: string;
  itemId: number;
}

const DetailInfoModal = (props: DetailInfoModalProps) => {
  const [content, setContent] = React.useState("");

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const updateInfo = async () => {
    try {
      await updateContentDescription(props.type, String(props.itemId), content);
      props.navigate(0);
    } catch (error) {
      toast.error("Info update fail");
      console.error(error);
    }
  };

  return (
    <Modal isOpen={props.visible} toggle={togModal} centered>
      <div className="mx-3 my-3">
        <h3>상세정보 수정</h3>
        <MyEditor value={content} onChange={setContent} />
        <div className="flex justify-content-end my-3">
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              updateInfo();
              props.setVisible(!props.visible);
            }}
          >
            적용
          </Button>
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
        </div>
      </div>
    </Modal>
  );
};

interface DetailUseAdviceModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  navigate: (path: number | string) => void;
  type: string;
  itemId: number;
}

const DetailUseAdviceModal = (props: DetailUseAdviceModalProps) => {
  const [content, setContent] = React.useState("");

  const togModal = () => {
    props.setVisible(!props.visible);
  };
  /* 아직 버튼 적용(함수 호출은 안함) */
  const updateAdvice = async () => {
    try {
      await updateContentInfo(props.type, String(props.itemId), content);
      props.navigate(0);
    } catch (error) {
      toast.error("Info update fail");
      console.error(error);
    }
  };

  return (
    <Modal isOpen={props.visible} toggle={togModal} centered>
      <div className="mx-3 my-3">
        <h3>이용안내 수정</h3>
        <MyEditor value={content} onChange={setContent} />
        <div className="flex justify-content-end my-3">
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              updateAdvice();
              props.setVisible(!props.visible);
            }}
          >
            적용
          </Button>
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
        </div>
      </div>
    </Modal>
  );
};


interface SiteDetailEditModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  id: number;
  navigate: (path: number | string) => void;
}

const SiteDetailEditModal = (props: SiteDetailEditModalProps) => {
  type SiteAmenityOption = { value: string | number; label: string };
  type SiteAmenityData = { id: string | number; name: string };

  const [siteTypes, setSiteTypes] = React.useState<Array<{ id: string | number; name: string }>>([]);
  const [siteAmenityOptions, setSiteAmenityOptions] = React.useState<SiteAmenityData[]>([]);

  const [permission] = useUserStore((state) => [state.permission]);

  const fetchSiteOptions = async () => {
    try {
      const response = await API.get(`/sites/info/${props.id}/?options=true`);
      const data = response.data;
      if (data?.site_types) setSiteTypes(data.site_types);
      if (data?.site_amenities) setSiteAmenityOptions(data.site_amenities);
    } catch (error) {
      console.log("Error fetching site types:", error);
    }
  };

  const [siteType, setSiteType] = React.useState<string | number>("");
  const [siteAmenities, setSiteAmenities] = React.useState<SiteAmenityOption[]>([]);

  const [openState, setOpenState] = React.useState<string>("");
  const [siteCategory, setSiteCategory] = React.useState("");
  const [shortName, setShortName] = React.useState("");

  const [usingInfo, setUsingInfo] = React.useState("");
  const [detailInfo, setDetailInfo] = React.useState("");
  const [reservationInfo, setReservationInfo] = React.useState("");
  const [customHeadTags, setCustomHeadTags] = React.useState("");

  const fetchSiteInfo = async () => {
    if (!permission) {
      return;
    }
    try {
      const response = await API.get(`/sites/info/${props.id}/`);
      const data = response.data;

      setSiteType(data.type?.id);
      if (data.amenities_info) {
        const amenities = data.amenities_info.map((amenity: { id: string | number; name: string }) => ({
          value: amenity.id,
          label: amenity.name,
        }));
        setSiteAmenities(amenities);
      } else {
        setSiteAmenities([]);
      }
      setOpenState(data.open_state);
      setSiteCategory(data.site_category);
      setShortName(data.short_name);
      setUsingInfo(data.using_info);
      setDetailInfo(data.detail_info);
      setReservationInfo(data.reservation_info);
      setCustomHeadTags(data.custom_head_tags || "");

    } catch (error) {
      console.error("Error fetching site info:", error);
    }
  }
  useEffect(() => {
    if (!props.id) return;
    if (!permission) {
      return;
    }

    fetchSiteInfo();
    fetchSiteOptions();
  }, [props.id, permission]);

  const handleUpdateSiteInfo = async () => {
    try {
      const siteInfo = {
        type: siteType,
        amenities_info: siteAmenities ? siteAmenities.map((amenity) => amenity.value) : undefined,
        open_state: openState,
        site_category: siteCategory,
        short_name: shortName,
        using_info: usingInfo,
        detail_info: detailInfo,
        reservation_info: reservationInfo,
        custom_head_tags: customHeadTags,
      };

      console.log("siteInfo", siteInfo);

      await API.put(`/sites/info/${props.id}/`, {
        info: siteInfo,
      });
      props.navigate(0);
    } catch (error) {
      console.error("Error updating site info:", error);
    }
  }

  const togModal = () => {
    props.setVisible(!props.visible);
  }

  if (!permission || !props.id) {
    return (
      <Modal isOpen={props.visible} toggle={togModal} centered>
        <div className="mx-3 my-3">
          <h3>사이트 정보 수정</h3>
          <p>권한이 없습니다.</p>
          <Button variant="secondary" className="ms-2" onClick={() => props.setVisible(!props.visible)}>
            닫기
          </Button>
        </div>
      </Modal>
    );
  }
  if (!siteTypes.length || !siteAmenityOptions.length) {
    return (
      <Modal isOpen={props.visible} toggle={togModal} centered>
        <div className="mx-3 my-3">
          <h3>사이트 정보 수정</h3>
          <p>사이트 타입 또는 편의시설 옵션을 불러오는 중입니다...</p>
          <Button variant="secondary" className="ms-2" onClick={() => props.setVisible(!props.visible)}>
            닫기
          </Button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal isOpen={props.visible} toggle={togModal} centered>
      <Row className="items-center g-3 mx-2 my-3">
        <Col lg={12}>
          <Label htmlFor="siteType" className="form-label fs-15">
            사이트 타입
          </Label>
          <select className="form-select mb-3" id="siteType" value={siteType} onChange={(e) => setSiteType(e.target.value)}>
            {siteTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>

          <Label htmlFor="siteAmenities" className="form-label fs-15">
            편의시설
          </Label>
          <Select
            isMulti
            options={siteAmenityOptions?.map((amenity) => ({ value: amenity.id, label: amenity.name }))}
            className="basic-multi-select mb-3"
            classNamePrefix="select"
            onChange={(selectedOptions: MultiValue<SiteAmenityOption>) => {
              setSiteAmenities([...selectedOptions]);
            }}
            value={siteAmenities}
            placeholder="편의시설을 선택해주세요"
          />

          <Label htmlFor="openState" className="form-label fs-15">
            오픈 상태
          </Label>
          <select className="form-select mb-3" id="openState" value={openState} onChange={(e) => setOpenState(e.target.value)}>
            <option value="open">오픈</option>
            <option value="pause">운영 일시정지</option>
            <option value="close">서비스종료</option>
            <option value="confirm">오픈예정</option>
            <option value="soon">검토중</option>
            <option value="wish">요청됨</option>
            <option value="dev">테스트</option>
          </select>

          <Label htmlFor="siteCategory" className="form-label fs-15">
            사이트 카테고리
          </Label>
          <select className="form-select mb-3" id="siteCategory" value={siteCategory} onChange={(e) => setSiteCategory(e.target.value)}>
            <option value="서울">서울</option>
            <option value="경기">경기</option>
            <option value="인천">인천</option>
            <option value="강원">강원</option>
            <option value="충청">충청</option>
            <option value="전라">전라</option>
            <option value="경상">경상</option>
            <option value="제주">제주</option>
            <option value="기타">기타</option>
            <option value="해외">해외</option>
          </select>

          <Label htmlFor="shortName" className="form-label fs-15">
            짧은 이름
          </Label>
          <Input type="text" id="shortName" value={shortName} onChange={(e) => setShortName(e.target.value)} />

          <div className="mt-3"></div>
          <Label htmlFor="usingInfo" className="form-label fs-15">
            이용안내
          </Label>
          <MyEditor
            uid="usingInfo"
            value={usingInfo} onChange={setUsingInfo} />

          <div className="mt-3"></div>
          <Label htmlFor="detailInfo" className="form-label fs-15">
            상세정보
          </Label>
          <MyEditor
            uid="detailInfo"
            value={detailInfo} onChange={setDetailInfo} />

          <div className="mt-3"></div>
          <Label htmlFor="reservationInfo" className="form-label fs-15">
            예약정보
          </Label>
          <MyEditor
            uid="reservationInfo"
            value={reservationInfo} onChange={setReservationInfo} />

            <div className="mt-3"></div>
            <Label htmlFor="customHeadTags" className="form-label fs-15">
              HEAD 태그
            </Label>
            <textarea
              id="customHeadTags"
              className="form-control mb-3"
              rows={6}
              value={customHeadTags}
              placeholder={'<meta name="naver-site-verification" content="..." />'}
              onChange={(event) => setCustomHeadTags(event.target.value)}
            />

        </Col>
        <div className="flex justify-content-end mb-3">
          <Button
            variant="secondary"
            className="ms-2"
            onClick={async () => {
              await handleUpdateSiteInfo();
              props.setVisible(!props.visible);
            }}
          >
            적용
          </Button>
          <Button
            variant="secondary"
            className="ms-2"
            onClick={() => {
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
        </div>
      </Row>
    </Modal>
  );
}


// export default ManagerModal
/* landing */
export { SloganModal, CarouselModal, FooterModal, DetailImgModal, FooterSnsEditModal, FooterSnsAddModal };
/* detail */
export { DetailInfoModal, DetailUseAdviceModal };
/* login */
export { LoginTitleImgModal };
/* map */
export { KakaoMapModal };

/* site */
export { SiteDetailEditModal };
